import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function appointmentReducer(
  state = initialState.appointments,
  action
) {
  switch (action.type) {
    case types.LOAD_APPOINTMENTS_SUCCESS:
      return action.appointments;
    case types.SAVE_APPOINTMENT_OPTIMISTIC:
      return state.map((appointments) =>
        appointments.appointmentID === action.appointments.appointmentID
          ? action.appointments
          : appointments
      );
    case types.DELETE_APPOINTMENT_OPTIMISTIC:
      return state.filter(
        (appointments) =>
          appointments.appointmentID !== action.appointments.appointmentID
      );
    case types.DELETE_APPOINTMENT_LAST_OPTIMISTIC:
      return action.appointments;
    case types.CREATE_APPOINTMENT_SUCCESS:
      return [...state, { ...action.appointments }];
    case types.RESET_APPOINTMENTS_SUCCESS:
      return initialState.appointments;
    default:
      return state;
  }
}
